import { Button } from '@occc/ui-design-system';

type CampaignComponentReadOnlyFooterActionsProps = {
  onCancel?: () => void;
  onNextStepClick?: () => void;
};

export const CampaignComponentReadOnlyFooterActions = ({
  onCancel,
  onNextStepClick,
}: CampaignComponentReadOnlyFooterActionsProps) => {
  return (
    <>
      {onCancel ? <Button onClick={onCancel}>Cancel</Button> : null}
      {onNextStepClick ? (
        <Button onClick={onNextStepClick} color='primary' variant='contained'>
          Next
        </Button>
      ) : null}
    </>
  );
};
